import React, { useState, useEffect, useContext } from 'react';

import { Context } from './StockManagerContext.jsx';
import ShipmentsModal from './ShipmentsModal.jsx';
import AddToShipmentModal from './AddToShipmentModal.jsx';

export default function ShipmentButtons({ getMethods }) {

    const [isActive, setIsActive] = useState(false);
    const [showOrderList, setShowOrderList] = useState(false);
    const [product, setProduct] = useState(null);
    const { orders, getOrders } = useContext(Context);

    const hasOrders = () => getOrders().length > 0;

    useEffect(() => {
        getMethods({
            addToOrder: (product) => {

                console.log('Add to order', product);

                if ( !hasOrders() ) {
                    console.log('No existing orders. Opening full order form.', getOrders());
                    // Todo - Use context instead of global actions here.
                    setShowOrderList(true);
                    window.OrderForm.openNewOrder(product);
                    return;
                }

                const isSerialised = !product.enableQty;
                const existingSkus = getOrders().flatMap(o => o.products.map(p => p.sku));

                if (isSerialised && existingSkus.includes(product.sku)) {
                    alert('Error: This serialised item is already selected on an order.')
                    return;
                }

                setProduct(product);
                // Show orderlist below order modal
                setShowOrderList(true);
                // And show order modal
                setIsActive(true);

            },
            showOrderList: () => {
                setShowOrderList(true);
            }
        });
    }, []);

    return (
        <>
            <a className={`btn ${orders.length > 0 ? 'btn-success' : 'btn-light'} mr-1`} onClick={_ => setShowOrderList(true)} style={{ cursor: 'pointer' }}>
                Quote ({orders.length})
            </a>

            <ShipmentsModal isActive={showOrderList} onHide={() => setShowOrderList(false)} />

            <AddToShipmentModal
                isActive={isActive}
                setProduct={setProduct}
                setIsActive={setIsActive}
                product={product}
                onHide={() => { setProduct(null); setIsActive(false); }}
            />
        </>
    );
}
